export const AtlassianAdminLogoNeutral = () => (
  <svg
    width="424"
    height="48"
    viewBox="0 0 424 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2305_6034)">
      <path
        d="M10.2888 19.9999C9.78882 19.3999 8.98882 19.4999 8.58882 20.1999L0.0888177 37.1999C-0.211182 37.7999 0.288818 38.5999 0.988818 38.5999H12.7888C13.1888 38.5999 13.4888 38.3999 13.6888 37.9999C16.2888 32.7999 14.6888 24.7999 10.2888 19.9999Z"
        fill="url(#paint0_linear_2305_6034)"
      />
      <path
        d="M16.4888 4.6C11.7888 12.1 12.0888 20.4 15.1888 26.7C18.2888 33 20.6888 37.7 20.8888 38.1C21.0888 38.5 21.3888 38.7 21.7888 38.7H33.5888C34.3888 38.7 34.7888 37.9 34.4888 37.2C34.4888 37.2 18.5888 5.4 18.1888 4.6C17.8888 3.8 16.8888 3.8 16.4888 4.6Z"
        fill="#77859B"
      />
      <path
        d="M155.049 18.3586C155.049 22.5596 156.998 25.8946 164.621 27.3666C169.169 28.3196 170.121 29.0556 170.121 30.5716C170.121 32.0446 169.168 32.9966 165.963 32.9966C162.238 32.9966 157.821 31.7406 154.919 30.0086V36.8516C157.214 37.9776 160.246 39.2336 165.876 39.2336C173.845 39.2336 177.007 35.6826 177.007 30.3986M177.007 30.3986C177.007 25.4176 174.365 23.0796 166.916 21.4766C162.802 20.5666 161.805 19.6576 161.805 18.3586C161.805 16.7126 163.278 16.0196 166.006 16.0196C169.298 16.0196 172.546 17.0156 175.621 18.4016V11.8616C173.455 10.7786 170.121 9.9126 166.223 9.9126C158.86 9.9126 155.049 13.1186 155.049 18.3586"
        fill="#44546F"
      />
      <path
        d="M257.429 10.3457V38.8007H263.492V17.1027L266.047 22.8627L274.623 38.8007H282.245V10.3457H276.182V28.7097L273.886 23.3827L267 10.3457H257.429Z"
        fill="#44546F"
      />
      <path
        d="M218.863 10.3457H212.237V38.8007H218.863V10.3457Z"
        fill="#44546F"
      />
      <path
        d="M204.592 30.3986C204.592 25.4176 201.95 23.0796 194.501 21.4766C190.387 20.5666 189.39 19.6576 189.39 18.3586C189.39 16.7126 190.863 16.0196 193.591 16.0196C196.883 16.0196 200.131 17.0156 203.206 18.4016V11.8616C201.04 10.7786 197.706 9.9126 193.808 9.9126C186.445 9.9126 182.634 13.1176 182.634 18.3576C182.634 22.5586 184.583 25.8936 192.206 27.3656C196.754 28.3186 197.706 29.0546 197.706 30.5706C197.706 32.0436 196.753 32.9956 193.548 32.9956C189.823 32.9956 185.406 31.7396 182.504 30.0076V36.8506C184.799 37.9766 187.831 39.2326 193.461 39.2326C201.43 39.2326 204.592 35.6826 204.592 30.3986Z"
        fill="#44546F"
      />
      <path
        d="M103.572 10.3457V38.8007H117.192L119.336 32.6507H110.242V10.3457H103.572Z"
        fill="#44546F"
      />
      <path
        d="M76.663 10.3457V16.4957H84.025V38.8007H90.695V16.4957H98.578V10.3457H76.663Z"
        fill="#44546F"
      />
      <path
        d="M66.991 10.3457H58.251L48.329 38.8007H55.908L57.315 34.0087C58.999 34.5017 60.778 34.7717 62.621 34.7717C64.464 34.7717 66.244 34.5027 67.927 34.0087L69.334 38.8007H76.913L66.991 10.3457ZM62.621 28.8787C61.354 28.8787 60.131 28.6937 58.974 28.3547L62.621 15.9327L66.268 28.3547C65.111 28.6937 63.888 28.8787 62.621 28.8787Z"
        fill="#44546F"
      />
      <path
        d="M140.673 10.3457H131.933L122.011 38.8007H129.59L130.997 34.0087C132.681 34.5017 134.46 34.7717 136.303 34.7717C138.146 34.7717 139.926 34.5027 141.609 34.0087L143.016 38.8007H150.595L140.673 10.3457ZM136.303 28.8787C135.036 28.8787 133.813 28.6937 132.656 28.3547L136.303 15.9327L139.95 28.3547C138.793 28.6937 137.57 28.8787 136.303 28.8787Z"
        fill="#44546F"
      />
      <path
        d="M242.742 10.3457H234.002L224.08 38.8007H231.659L233.066 34.0087C234.75 34.5017 236.529 34.7717 238.372 34.7717C240.215 34.7717 241.995 34.5027 243.678 34.0087L245.085 38.8007H252.664L242.742 10.3457ZM238.372 28.8787C237.105 28.8787 235.882 28.6937 234.725 28.3547L238.372 15.9327L242.019 28.3547C240.862 28.6937 239.639 28.8787 238.372 28.8787Z"
        fill="#44546F"
      />
      <path
        d="M303.105 31.9868L300.575 38.7968H295.929L307.845 8.5708H313.089L325.005 38.7968H320.359L317.829 31.9418C315.115 32.4948 312.768 32.7698 310.33 32.7698C308.03 32.7698 305.684 32.4948 303.107 31.9878L303.105 31.9868ZM316.584 28.4908L310.465 11.9288L304.346 28.5358C306.6 28.9038 308.487 29.0888 310.326 29.0888C312.259 29.0888 314.237 28.8588 316.583 28.4898L316.584 28.4908Z"
        fill="#44546F"
      />
      <path
        d="M343.356 34.6557C341.884 37.6917 339.124 39.2557 335.581 39.2557C329.462 39.2557 326.38 34.0577 326.38 27.2947C326.38 20.8087 329.6 15.3337 336.041 15.3337C339.399 15.3337 341.976 16.8517 343.355 19.8417V6.17871H347.312V38.7967H343.355L343.356 34.6557ZM336.639 35.5757C340.181 35.5757 343.356 33.3217 343.356 28.2147V26.3747C343.356 21.2687 340.458 19.0137 337.1 19.0137C332.637 19.0137 330.337 21.9587 330.337 27.2947C330.337 32.8157 332.545 35.5757 336.64 35.5757H336.639Z"
        fill="#44546F"
      />
      <path
        d="M372.842 38.7965H368.885V24.9015C368.885 20.7605 367.229 18.9215 363.457 18.9215C359.776 18.9215 357.246 21.3595 357.246 26.0065V38.7965H353.289V15.7935H357.246V19.5655C358.718 16.8505 361.433 15.3335 364.515 15.3335C368.425 15.3335 371.094 17.3125 372.244 20.9455C373.532 17.4035 376.615 15.3335 380.433 15.3335C385.586 15.3335 388.438 18.8295 388.438 25.3155V38.7955H384.482V26.0055C384.482 21.2675 382.826 18.9205 379.053 18.9205C375.372 18.9205 372.842 21.3585 372.842 26.0055V38.7965Z"
        fill="#44546F"
      />
      <path
        d="M395.978 6.96094C397.588 6.96094 398.738 7.97294 398.738 9.72094C398.738 11.4689 397.588 12.4819 395.978 12.4819C394.368 12.4819 393.218 11.4689 393.218 9.72094C393.218 7.97294 394.368 6.96094 395.978 6.96094ZM393.954 15.7939H397.911V38.7969H393.954V15.7939Z"
        fill="#44546F"
      />
      <path
        d="M423.441 38.7965H419.484V24.9015C419.484 20.7605 417.828 18.9215 414.056 18.9215C410.375 18.9215 407.845 21.3595 407.845 26.0065V38.7965H403.888V15.7935H407.845V19.5655C409.317 16.8505 412.032 15.3335 415.114 15.3335C420.405 15.3335 423.441 18.9675 423.441 25.3155V38.7965Z"
        fill="#44546F"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2305_6034"
        x1="14.9049"
        y1="22.6043"
        x2="5.94992"
        y2="38.1143"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#304566" />
        <stop offset="0.923" stopColor="#77859B" />
      </linearGradient>
      <clipPath id="clip0_2305_6034">
        <rect width="424" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
